import React, { useCallback } from 'react';
import { Flex, Pane, Text } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import { Toolbar } from '@leverege/ui-plugin';
import classnames from 'classnames';
import I18N from '@leverege/i18n';
import S from './NoDataView.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ns = 'molten.dataViewers.views.NoDataView';
const {
  t,
  tIcon
} = I18N.ns(ns);
const dNoDataTitleKey = 'noDataTitle';
const dNoDataBodyKey = 'noDataBody';
const dNoDataIconKey = 'noData';
const dtNoDataIconKey = 'noDataIcon';
const dNoDataDocLinkKey = 'noDataDocLink';
const dNoSearchResultsTitleKey = 'noSearchResultsTitle';
const dNoSearchResultsBodyKey = 'noSearchResultsBody';
const dNoSearchResultsIconKey = 'noSearchResults';
const dtNoSearchResultsIconKey = 'noSearchResultsIcon';
export default function NoDataView(props) {
  const {
    filters,
    relationship: {
      blueprint,
      attribute,
      path
    },
    objectType,
    client = 'TableDataViewer',
    noDataTitleKey = dNoDataTitleKey,
    noDataBodyKey = dNoDataBodyKey,
    noDataIconKey = dNoDataIconKey,
    tNoDataIconKey = dtNoDataIconKey,
    noDataDocLinkKey = dNoDataDocLinkKey,
    noSearchResultsTitleKey = dNoSearchResultsTitleKey,
    noSearchResultsBodyKey = dNoSearchResultsBodyKey,
    noSearchResultsIconKey = dNoSearchResultsIconKey,
    tNoSearchResultsIconKey = dtNoSearchResultsIconKey,
    defaultNoDataTitle = blueprint?.namePlural || blueprint?.name
  } = props;
  const resolveTranslation = useCallback((key, dVal, isIcon = false) => {
    const getFunc = isIcon ? 'getIcon' : 'getString';
    return attribute?.[getFunc]?.(key) || blueprint?.[getFunc]?.(key) || dVal;
  }, [attribute, blueprint]);
  if (filters?.filter == null) {
    const noDataTitle = resolveTranslation(noDataTitleKey, Config.get('NoDataView', noDataTitleKey, defaultNoDataTitle || t(noDataTitleKey)));
    const noDataBody = resolveTranslation(noDataBodyKey, Config.get('NoDataView', noDataBodyKey, t(noDataBodyKey)));
    const noDataIcon = resolveTranslation(noDataIconKey, Config.get('NoDataView', 'noDataIcon', tIcon(tNoDataIconKey, 'https://molten-ui-assets.storage.googleapis.com/no-data.svg')), true);
    const noDataDimensions = Config.get('NoDataView', 'noSearchResultsIconDimensions', {
      height: 224,
      width: 224
    });
    const docLink = resolveTranslation(noDataDocLinkKey, Config.get('NoDataView', 'noDataDocLink'));
    return /*#__PURE__*/_jsxs(Pane, {
      variant: "noDataView",
      className: classnames(S.win, S.noDataContainer),
      layout: "flex:rowL",
      children: [/*#__PURE__*/_jsx("img", {
        alt: t('noData'),
        src: noDataIcon,
        height: noDataDimensions.height,
        width: noDataDimensions.width
      }), /*#__PURE__*/_jsx(Pane, {
        variant: "noDataBody",
        children: /*#__PURE__*/_jsxs(Flex, {
          variant: "colXL",
          justify: "center",
          vFill: true,
          children: [/*#__PURE__*/_jsxs(Pane, {
            variant: "noDataContent",
            layout: "flex:colL",
            children: [/*#__PURE__*/_jsx(Text, {
              variant: "sectionTitle",
              children: noDataTitle
            }), /*#__PURE__*/_jsx(Text, {
              variant: "sectionBody",
              children: noDataBody
            }), docLink ? /*#__PURE__*/_jsx("a", {
              style: {
                textDecoration: 'none'
              },
              target: "blank",
              href: docLink,
              children: /*#__PURE__*/_jsx(Text, {
                variant: "link",
                children: t('documentation')
              })
            }) : null]
          }), /*#__PURE__*/_jsx(Toolbar, {
            matchContext: {
              client,
              use: 'noData',
              objectType,
              path
            },
            context: {
              clientProps: props
            },
            hasContextMenu: false,
            prefer: "text",
            variant: "noData"
          })]
        })
      })]
    });
  }
  const noSearchResultsTitle = resolveTranslation(noSearchResultsTitleKey, Config.get('NoDataView', 'noSearchResultsTitle', t(noSearchResultsTitleKey)));
  const noSearchResultsBody = resolveTranslation(noSearchResultsBodyKey, Config.get('NoDataView', 'noSearchResultsBody', t(noSearchResultsBodyKey)));
  const noSearchResultsIcon = resolveTranslation(noSearchResultsIconKey, Config.get('NoDataView', 'noSearchResultsIcon', tIcon(tNoSearchResultsIconKey, 'https://molten-ui-assets.storage.googleapis.com/no-search-results.svg')), true);
  const noSearchDimensions = Config.get('NoDataView', 'noSearchResultsIconDimensions', {
    height: 224,
    width: 224
  });
  return /*#__PURE__*/_jsxs(Pane, {
    variant: "noDataView",
    className: classnames(S.win, S.noDataContainer),
    layout: "flex:rowL",
    children: [/*#__PURE__*/_jsx("img", {
      alt: t('noSearchResults'),
      src: noSearchResultsIcon,
      height: noSearchDimensions.height,
      width: noSearchDimensions.width
    }), /*#__PURE__*/_jsx(Pane, {
      variant: "noDataBody",
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "colXL",
        justify: "center",
        vFill: true,
        children: [/*#__PURE__*/_jsxs(Pane, {
          variant: "noDataContent",
          layout: "flex:colL",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "sectionTitle",
            children: noSearchResultsTitle
          }), /*#__PURE__*/_jsx(Text, {
            variant: "sectionBody",
            children: noSearchResultsBody
          })]
        }), /*#__PURE__*/_jsx(Toolbar, {
          matchContext: {
            client,
            use: 'noResults',
            objectType,
            path
          },
          context: {
            clientProps: props
          },
          hasContextMenu: false,
          prefer: "text",
          variant: "noData"
        })]
      })
    })]
  });
}